import { css } from '@emotion/core'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

export const completeWithPrinterBackgroundStyle = css(
  {
    boxSizing: 'border-box',
    width: '100%',
    minHeight: 820,
    paddingTop: 60,
    backgroundColor: '#F2F2F2',
  },
  createSelfCheckinResponsiveStyle({
    portrait: { minHeight: 1180 },
    landscape13: { minHeight: 1024, paddingTop: 56 },
  }),
)

export const completeWithPrinterCardStyle = css(
  {
    margin: '0 auto',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    whiteSpace: 'break-spaces',

    '.head-line-block': {
      boxSizing: 'border-box',
      height: 112,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 24,
      borderBottom: '1px solid #CCCCCC',
      '> img': { width: 48, height: 48 },
      '> span': {
        color: '#F2A40B',
        fontSize: 22,
        lineHeight: '30px',
        fontWeight: 'bold',
        letterSpacing: 1.1,
      },
    },
    '.announce-block': {
      minHeight: 574,
    },
    '.checkin-message-block': {
      textAlign: 'center',
      '.checkin-message, > .front-support-message': {
        color: '#272727',
        fontSize: 22,
        lineHeight: '35px',
        fontWeight: 'bold',
        letterSpacing: 3.3,
      },
      '.room-block': {
        boxSizing: 'border-box',
        margin: 0,
        overflow: 'hidden',
        color: '#272727',
        textAlign: 'center',
        fontWeight: 'bold',
        background: '#F5F5F5',
        border: '2px solid #CCCCCC',
        borderRadius: 10,
        '.sub-text': {
          boxSizing: 'border-box',
          padding: '16px 8px',
          color: '#676767',
          fontSize: 16,
          lineHeight: '22px',
          letterSpacing: 1.6,
        },
        '.number-text': {
          boxSizing: 'border-box',
          minHeight: 54,
          padding: '0 8px 12px',
          color: '#272727',
          fontSize: 32,
          lineHeight: '42px',
          letterSpacing: 1.6,
          borderBottom: '1px solid #CCCCCC',
        },
      },
      '> button': {
        margin: '0 !important',
      },
    },
    '.printer-demo-block': {
      position: 'relative',
      width: 474,
      height: 474,
      '> img': {
        position: 'absolute',
        inset: 0,
        width: 474,
        height: 474,
        opacity: 0,
        animation: 'complete-printer-image-switch 10s infinite',
        '&:nth-of-type(1)': { animationDelay: '0s' },
        '&:nth-of-type(2)': { animationDelay: '5s' },
      },
    },
    '@keyframes complete-printer-image-switch': {
      '0%': { opacity: 0 },
      '5%': { opacity: 1 },
      '60%': { opacity: 1 },
      '65%': { opacity: 0 },
    },
  },
  { width: 1062, minHeight: 686 },
  createSelfCheckinResponsiveStyle({
    portrait: {
      borderRadius: 0,
      width: 820,
      minHeight: 612,
      '.announce-block': { minHeight: 500 },
      '.printer-demo-block': {
        width: 346,
        height: 346,
        '> img': { width: 346, height: 346 },
      },
    },
    landscape13: {
      width: 1230,
      minHeight: 779,
      '.head-line-block': {
        height: 116,
        '> span': { fontSize: 26, lineHeight: '36px', letterSpacing: 1.3 },
      },
      '.announce-block': { minHeight: 663 },
      '.checkin-message-block': {
        '.checkin-message, > .front-support-message': { fontSize: 26, lineHeight: '42px', letterSpacing: 3.9 },
        '.room-block': {
          '.sub-text': { padding: '20px 8px', fontSize: 20, lineHeight: '28px', letterSpacing: 2 },
          '.number-text': { minHeight: 64, paddingBottom: 14, fontSize: 36, lineHeight: '48px', letterSpacing: 1.8 },
        },
      },
      '.printer-demo-block': {
        width: 562,
        height: 562,
        '> img': { width: 562, height: 562 },
      },
    },
  }),
)

export const completeWithPrinterRoomLayoutStyle = css(
  {
    '.announce-block': {
      boxSizing: 'border-box',
      display: 'grid',
      gridTemplateColumns: '458px 474px',
      columnGap: 40,
      alignItems: 'start',
      padding: '50px 50px 0 40px',
    },
    '.checkin-message-block': {
      width: 458,
      paddingTop: 10,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 32,
      '.checkin-message': {
        width: '100%',
      },
      '.room-block': {
        width: '100%',
        margin: 0,
      },
      '> button': {
        margin: '0 !important',
      },
    },
  },
  createSelfCheckinResponsiveStyle({
    portrait: {
      '.announce-block': {
        gridTemplateColumns: '400px 346px',
        columnGap: 12,
        padding: '50px 50px 0 12px',
      },
      '.checkin-message-block': {
        width: 400,
        paddingTop: 0,
        '.room-block': {
          width: 341,
          alignSelf: 'center',
        },
      },
    },
    landscape13: {
      '.announce-block': {
        gridTemplateColumns: '458px 562px',
        columnGap: 74,
        padding: '51px 50px 0 86px',
      },
      '.checkin-message-block': {
        width: 458,
        paddingTop: 29,
      },
    },
  }),
)

export const completeWithPrinterKeyLayoutStyle = css(
  createSelfCheckinResponsiveStyle({
    landscape13: {
      '.checkin-message-block': {
        gap: 0,
        '.checkin-message': {
          lineHeight: '35px',
        },
        '.room-block': {
          marginTop: 40,
        },
        '> button': {
          marginTop: '32px !important',
        },
      },
    },
  }),
)

export const completeWithPrinterFrontLayoutStyle = css(
  {
    '.checkin-message-block': {
      paddingTop: 138,
      gap: 32,
      '.front-support-message': {
        width: '100%',
      },
    },
  },
  createSelfCheckinResponsiveStyle({
    portrait: {
      '.checkin-message-block': {
        paddingTop: 70,
        gap: 40,
      },
    },
    landscape13: {
      '.checkin-message-block': {
        paddingTop: 179,
        gap: 32,
        '.front-support-message': {
          lineHeight: '35px',
        },
      },
    },
  }),
)
